import React, { useState } from "react";
import "./about.css";
import { getImageUrl } from "../../config/s3Config";
import Back from "../common/back/Back";

const About = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openImageModal = (imageSrc, imageAlt) => {
    setSelectedImage({ src: imageSrc, alt: imageAlt });
    setIsModalOpen(true);
  };

  const closeImageModal = () => {
    setIsModalOpen(false);
    setSelectedImage(null);
  };

  return (
    <>
    
      <Back title="About Us" />

      {/* Hero Section (Modern) */}
      <section className="hero-section modern" id="about-hero">
        <div className="hero-decor hero-decor-a" />
        <div className="hero-decor hero-decor-b" />
        <div className="container">
          <div className="hero-content">
            <div className="">
              <div className="eyebrow">Since 2009 • Vocational & Higher Education</div>
              <h1>
                Empowering <span className="gradient-text">Dreams</span>,<br /> Building <span className="gradient-text">Futures</span>
              </h1>
              <p className="hero-subtitle">
                For over a decade and a half, SDTI Campus has transformed lives with
                innovation, mentorship and globally aligned, career-focused learning.
              </p>
              <div className="hero-actions">
                <a href="/courses" className="btn-primary shadow">Explore Programs</a>
                <button className="btn-secondary outline">Get Prospectus</button>
              </div>
             
             
            </div>
           
          </div>
        </div>
      </section>

  {/* Chairman's Message (with design mode toggle) */}
  <ChairmanMessage openImageModal={openImageModal} />

 

      {/* Vision & Mission (Modern Redesign) */}
      <section className="vision-mission modern" id="vision-mission">
        <div className="vm-decor vm-decor-a" />
        <div className="vm-decor vm-decor-b" />
        <div className="vm-grid-lines" aria-hidden="true">
          {[...Array(6)].map((_,i)=>(<span key={i} />))}
        </div>
        <div className="container">
          <div className="section-header tight">
            <div className="eyebrow alt">Core Identity</div>
            <h2>Vision & Mission</h2>
            <p>What drives SDTI Campus forward – our promise to learners and the future</p>
          </div>

          <div className="vm-grid">
            <div className="vm-card vision pop-in" style={{animationDelay:'0.05s'}}>
              <div className="vm-card-head">
                <div className="vm-orb" aria-hidden="true">🎯</div>
                <h3>Vision</h3>
              </div>
              <h4 className="vm-title">Creating a World Winning Individual</h4>
              <p className="vm-text">
                We envision globally agile graduates – purpose–driven, adaptive and ethically grounded –
                empowered to inspire progress across industries and communities.
              </p>
              <ul className="vm-bullets">
                <li><span>🚀</span> Growth Mindset & Lifelong Learning</li>
                <li><span>🌍</span> Global Citizenship & Cultural Agility</li>
                <li><span>💡</span> Innovation with Human Impact</li>
              </ul>
              <div className="tags-row">
                <span>Excellence</span><span>Innovation</span><span>Global Impact</span>
              </div>
              <div className="glow-bar" />
            </div>

            <div className="vm-card mission pop-in" style={{animationDelay:'0.15s'}}>
              <div className="vm-card-head">
                <div className="vm-orb" aria-hidden="true">🚀</div>
                <h3>Mission</h3>
              </div>
              <h4 className="vm-title">To shape a generation of skilled and confident youth</h4>
              <p className="vm-text">
                We deliver transformative, industry–aligned learning ecosystems blending mentorship,
                technology and real–world immersion to elevate employability & social upliftment.
              </p>
              <ul className="vm-bullets">
                <li><span>🛠️</span> Competency Based Training</li>
                <li><span>🤝</span> Mentorship & Leadership Culture</li>
                <li><span>📈</span> Career & Community Impact</li>
              </ul>
              <div className="tags-row alt">
                <span>Skills Dev</span><span>Confidence</span><span>Career Growth</span>
              </div>
              <div className="glow-bar" />
            </div>
          </div>

          <div className="vm-meta-stats">
            <div className="vm-stat"><strong>15+ yrs</strong><span>Transforming Learners</span></div>
            <div className="vm-stat"><strong>50+</strong><span>Centres Nationwide</span></div>
            <div className="vm-stat"><strong>1000s</strong><span>Global Alumni</span></div>
          </div>
        </div>
      </section>

      {/* Key Features Section */}
      <section className="key-features">
        <div className="container">
          <div className="section-header">
            <h2>Why Choose SDTI Campus?</h2>
            <p>Discover what makes us the preferred choice for quality education</p>
          </div>
          
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">🏢</div>
              <h3>Nationwide Presence</h3>
              <p>50+ Branch across Sri Lanka, making quality education accessible to all.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">🌐</div>
              <h3>International Partnerships</h3>
              <p>Collaborations with globally recognized universities and institutions.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">💻</div>
              <h3>Modern Learning</h3>
              <p>State-of-the-art facilities and technology-driven educational approaches.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">👥</div>
              <h3>Expert Faculty</h3>
              <p>Experienced professionals dedicated to student success and development.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">🎯</div>
              <h3>Industry Focus</h3>
              <p>Programs designed to meet current industry demands and future trends.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">🏆</div>
              <h3>Proven Success</h3>
              <p>Thousands of successful graduates building successful careers worldwide.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Achievements & Accreditations (Modern) */}
      <section className="achievements modern" id="achievements">
        <div className="achv-decor achv-decor-a" />
        <div className="achv-decor achv-decor-b" />
        <div className="container">
          <div className="section-header compactish">
            <div className="eyebrow alt">Recognition</div>
            <h2>Achievements & Accreditations</h2>
            <p>Global standards, quality assurance and industry partnerships validating our journey</p>
          </div>

          <div className="achv-stats">
            {[{n:'15+',l:'Years of Excellence'},{n:'50+',l:'Centres Island-wide'},{n:'1000s',l:'Successful Alumni'},{n:'10+',l:'Key Accreditations'}].map(s=>
              <div key={s.l} className="achv-stat"><strong>{s.n}</strong><span>{s.l}</span></div>
            )}
          </div>

          <div className="achv-grid">
            {[
              { img:getImageUrl('/images/logos/ugc_recognized.png'), label:'UGC Recognized', type:'Academic' },
              { img:getImageUrl('/images/logos/iso.png'), label:'ISO Certified', type:'Quality' },
              { img:getImageUrl('/images/logos/iqa logo png.png'), label:'IQA Accredited', type:'Quality' },
              { img:getImageUrl('/images/logos/IIC1.png'), label:'IIC Certified', type:'Innovation' },
              { img:getImageUrl('/images/logos/SILVER-WES-logo-NEW.png'), label:'WES Silver Partner', type:'Global' },
              { img:getImageUrl('/images/logos/sdti.png'), label:'SDTI Campus', type:'Identity' },
              { img:getImageUrl('/images/logos/Logo---EDU (2).png'), label:'Educational Partner', type:'Partnership' },
              { img:getImageUrl('/images/logos/HQ.png'), label:'Quality Assured', type:'Quality' }
            ].map((l,i)=> (
              <div key={l.label} className="achv-card pop-in" style={{animationDelay: `${0.05*i}s`}}>
                <div className="achv-card-front">
                  <div className="achv-logo-wrap">
                    <img 
                      src={l.img} 
                      alt={l.label} 
                      loading="lazy" 
                      onClick={() => openImageModal(l.img, l.label)}
                      style={{ cursor: 'pointer' }}
                    />
                  </div>
                  <h4>{l.label}</h4>
                  <span className="achv-tag">{l.type}</span>
                </div>
                <div className="achv-card-back">
                  <p>{l.label} reflects our ongoing commitment to internationally benchmarked educational quality.</p>
                </div>
              </div>
            ))}
          </div>

          <div className="achv-note">
            <p><strong>Continuous Improvement:</strong> Each accreditation drives curriculum enhancement, learner employability and assurance for parents & industry partners.</p>
          </div>
        </div>
      </section>

      {/* Awards WEB Post */}

      <Awards openImageModal={openImageModal} />

      {/* Call to Action */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Start Your Journey?</h2>
            <p>Join thousands of students who have transformed their lives with SDTI Campus</p>
            <div className="cta-buttons">
              <button className="btn-primary">Explore Programs</button>
              <button className="btn-secondary">Contact Us</button>
            </div>
          </div>
        </div>
      </section>

      {/* Image Modal */}
      {isModalOpen && (
        <div className="image-modal-overlay" onClick={closeImageModal}>
          <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close-btn" onClick={closeImageModal}>×</button>
            <img 
              src={selectedImage?.src} 
              alt={selectedImage?.alt} 
              className="modal-image"
            />
            <div className="modal-image-caption">{selectedImage?.alt}</div>
          </div>
        </div>
      )}
    </>
  );
};

export default About;

// Awards WEB Post

// ... existing code ...

const Awards = ({ openImageModal }) => {
  return (
    <section className="awards-section">
      <div className="container">
        <div className="section-header text-center mb-5">
          <h2 className="display-4 fw-bold text-gradient mb-3">Awards & Recognition</h2>
          <p className="lead text-muted">Celebrating our achievements and contributions to education excellence</p>
        </div>
        
        <div className="awards-grid">
          {[
            { img: getImageUrl('/images/Awards WEB Post/web 360x640 1.png'), title: 'Excellence Award 2024', category: 'Education', year: '2024' },
            { img: getImageUrl('/images/Awards WEB Post/web 360x640 2.png'), title: 'Quality Leadership', category: 'Innovation', year: '2024' },
            { img: getImageUrl('/images/Awards WEB Post/web 360x640 3 copy.png'), title: 'Student Success', category: 'Achievement', year: '2023' },
            { img: getImageUrl('/images/Awards WEB Post/web 360x640 4 copy.png'), title: 'Community Impact', category: 'Service', year: '2023' },
            { img: getImageUrl('/images/Awards WEB Post/web 360x640 5.png'), title: 'Academic Excellence', category: 'Education', year: '2023' },
            { img: getImageUrl('/images/Awards WEB Post/web 360x640 6.png'), title: 'Innovation Award', category: 'Technology', year: '2022' },
            { img: getImageUrl('/images/Awards WEB Post/web 360x640 7.png'), title: 'Leadership Recognition', category: 'Management', year: '2022' },
            { img: getImageUrl('/images/Awards WEB Post/web 360x640 8.png'), title: 'Excellence in Teaching', category: 'Education', year: '2022' },
            { img: getImageUrl('/images/Awards WEB Post/web 360x640 9.png'), title: 'Outstanding Achievement', category: 'Recognition', year: '2021' }
          ].map((award, index) => (
            <div key={award.title} className="award-card modern-card" style={{animationDelay: `${0.1 * index}s`}}>
              <div className="award-image-wrapper">
                <img 
                  src={award.img} 
                  alt={award.title} 
                  loading="lazy" 
                  className="award-image" 
                  onClick={() => openImageModal(award.img, award.title)}
                  style={{ cursor: 'pointer' }}
                />
                <div className="award-overlay">
                  <div className="award-year">{award.year}</div>
                </div>
              </div>
              <div className="award-content">
                <h4 className="award-title">{award.title}</h4>
                <span className="award-category badge bg-primary">{award.category}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// ... existing code ...
  



// Chairman Message 



// Chairman Message extracted for easier design experimentation
const ChairmanMessage = ({ openImageModal }) => {
  return (
    <section className="chairman-message redesigned">
      <div className="container">
        <div className="section-header compact">
          <h2>Message from Our Chairman</h2>
          <p>Vision, resilience and transformation shaping student success</p>
        </div>
        <div className="chairman-flex alt-layout">
          <div className="chairman-photo">
            <div className="photo-frame gradient-border">
              <div className="photo-container depth">
                <img
                  src={getImageUrl("/images/Graduation Special/379923268_251494751199518_8158933241376544005_n-mi.jpeg")}
                  alt="Chairman Dr. Shan Bandara"
                  loading="lazy"
                  onClick={() => openImageModal(getImageUrl('/images/Graduation Special/379923268_251494751199518_8158933241376544005_n-mi.jpeg'), 'Chairman Dr. Shan Bandara')}
                  style={{ cursor: 'pointer' }}
                />
                <div className="photo-overlay show-always">
                  <div className="overlay-content">
                    <h4>Dr. Shan Bandara</h4>
                    <p>Chairman & Managing Director</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="chairman-text enhanced">
            <p className="message-intro elevated">
              At SDTI Campus, our journey over the past fifteen years has been one of vision, resilience, and transformation.
            </p>
            <div className="message-highlights grid-3">
              {[
                { icon: "🌟", title: "Vision & Growth", text: "From a humble vocational institute to a national movement." },
                { icon: "🌍", title: "Global Reach", text: "Thousands empowered locally – an expanding international footprint." },
                { icon: "💼", title: "Career Ready", text: "Graduates equipped for real-world success, not just exams." }
              ].map((h) => (
                <div key={h.title} className="highlight-item cardish">
                  <div className="highlight-icon swirl-bg">{h.icon}</div>
                  <div className="highlight-text">
                    <h4>{h.title}</h4>
                    <p>{h.text}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="signature minimal">
              <div className="signature-line" />
              <p>
                <strong>With warm wishes for your success,</strong>
                <br />
                <strong>Dr. Shan Bandara</strong>
                <br />
                <span className="designation">Chairman / Managing Director</span>
                <br />
                <span className="qualifications">
                  Ph.D, LLB (UK), LLM (UK), Attorney-at-Law (Rdg.)<br />HND, PGD, Council & Diploma in Psychology, HDCGD,<br />CACC, TOT, English (UK), DET Specialist Training
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
